<template>
  <div>
    <b-row>
      <b-col cols="12" sm="12" md="9">
        <b-row>
          <b-col cols="12" sm="12" md="6">
            <div class="d-inline-block">
              <h4 class="d-inline">Unit:&nbsp;</h4>
              <p class="d-inline">{{ unitInfo.Unit }}</p>
              <b-button size="sm" class="edit-btn" @click="editUnitInfo">
                <i class="fa fa-pencil text-white"></i>
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="4">
            <div class="d-inline-block">
              <h4 class="d-inline">Status:&nbsp;</h4>
              <p class="d-inline">{{ unitInfo.Occupancy }}</p>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12" md="6">
            <div class="d-inline-block">
              <h4 class="d-inline">Unit Spec:&nbsp;</h4>
              <p class="d-inline">{{ unitInfo.description_summary }}</p>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="4">
            <div class="d-inline-block">
              <h4 class="d-inline">Square Footage:&nbsp;</h4>
              <p class="d-inline">{{ unitInfo.squareFoot || 0 }} sqft.</p>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="12" md="3">
        <img
          :src="
            unitInfo.product_summary.images.alternateImages[0].fileUrl
              ? unitInfo.product_summary.images.alternateImages[0].fileUrl
              : '@/assets/images/building.jpg'
          "
          class="image"
        />
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
export default {
  props: {
    unitInfo: {
      type: Object,
      required: true,
      default: () => ({
        unitNumber: "#1",
        status: "Vacant",
        unitSpec: "0 Bed - 1 Bath",
        squareFootage: "20000",
        imageSrc: "@/assets/images/building.jpg",
      }),
    },
  },
  methods: {
    editUnitInfo() {
      this.$router.push({
        name: "Update Unit Info",
        params: { id: this.unitInfo._id, data: this.unitInfo},
      });
    },
  },
};
</script>

<style scoped>
.image {
  width: 100%;
  max-width: 255px;
  height: auto;
  min-height: 130px;
  object-fit: cover;
}
.edit-btn {
  border-radius: 50px;
  height: 24px;
  width: 24px;
  line-height: 20px;
  padding: 0;
  margin-left: 5px;
}

@media (max-width: 576px) {
  .image {
    max-width: 100%;
    margin-left: 0;
    margin-top: 0;
  }
}
</style>
